module.exports = __webpack_public_path__ + "img/Weapon_227.2a42ac40.png";